import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { Cookie } from 'ng2-cookies/ng2-cookies';
import { SimpleGlobal } from 'ng2-simple-global';
import { LoginService } from '../../_services/login.service';
import { ComunicateComponentService } from '../../_services/comunicate-component.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
  providers: [LoginService, ComunicateComponentService]
})
export class LoginComponent implements OnInit {
  cookies: Object;
  model: any = {};
  constructor(
    private sg: SimpleGlobal,
    private router: Router,
    private loginservice: LoginService,
    private comunicateComponentService: ComunicateComponentService
  ) {

    this.loginservice.isLogin();
  }

  ngOnInit() {
  }

  @Output() notify: EventEmitter<string> = new EventEmitter<string>();

  data = <any>{}; // type script object assignment

  FormSubmit() {
    var uname = this.data.username;
    var pass = this.data.password;

    // console.log(uname);
    // // var key = btoa(btoa(uname) + '??' + btoa(pass));
    this.loginservice.login(uname, pass).
      subscribe(
      data => {
        // this.notify.emit('hello');
        // //this.comunicateComponentService.header(true);
        if (data.err == 1) {
          Cookie.set('TokenKey', data.token);
          Cookie.set('id', data.id);
          Cookie.set('username', data.name);
           this.router.navigate(['dashboard']);
        } else {
          alert('Wrong Login details');
        }
      }
      )
  }

}



// WEBPACK FOOTER //
// C:/wamp64/www/duetz.repos/angular4/src/app/_components/login/login.component.ts